import type { ImageCaptureAccount } from "@rumble-it/common-lib/types/models/ImageCapture.interface";
import type { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input, Select } from "@rumbledirect/ui";
import { Form } from "antd";

interface ImageCaptureAccountFormCardProps {
  mutation: UseMutationResult<null, Error, ImageCaptureAccount, unknown>;
  loading?: boolean;
  initialValues?: ImageCaptureAccount;
  title?: string;
  buttonText?: string;
}

export const ImageCaptureAccountFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "ImageCapture account aanmaken",
  buttonText = "Aanmaken",
}: ImageCaptureAccountFormCardProps) => {
  return (
    <Card loading={loading} title={title}>
      <Form
        onFinish={mutation.mutate}
        layout="vertical"
        initialValues={initialValues}
      >
        <Form.Item
          name="title"
          label="Titel"
          rules={[{ required: true, message: "Titel is verplicht" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="clientId"
          label="Client ID"
          rules={[{ required: true, message: "Client ID is verplicht" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="clientSecret"
          label="Client Secret"
          rules={[{ required: true, message: "Client Secret is verplicht" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="stage" label="Stage">
          <Select
            options={[
              {
                value: "development",
                label: "Development",
              },
              {
                value: "production",
                label: "Productie",
              },
            ]}
          />
        </Form.Item>

        <Form.Item label={null}>
          <Button loading={mutation.isPending} type="primary" htmlType="submit">
            {buttonText}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
